<template>
  <div>
    <!-- 遮罩层立即出现 -->
    <transition name="fade">
      <div v-if="showPopup" class="modal-overlay" @click="$emit('hidePopup');"></div>
    </transition>

    <!-- 弹出框升起动画 -->
    <transition name="slide-up">
      <div v-show="showPopup" class="modal">
        <div v-show="showHeader" class="modal-header">
          <span class="title-span">{{ title }}</span>
          <CloseIcon v-active-touch class="close-icon interactive-icon" @click.native="$emit('hidePopup');" />
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
      </div>
    </transition>
</div>
</template>

<script>
import CloseIcon from "@/components/icons/CloseIcon.vue";

export default {
  components: {
    CloseIcon
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    showPopup: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped>

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100%);
}

.modal {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  box-shadow: 0px -1px 10.8px 0px #0000000F;
  z-index: 1000;
  background: #fff;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 23px;
  border-bottom: 1px solid #ddd;
  font-size: 18px;
  font-weight: 500;
  line-height: 21.6px;
  letter-spacing: -0.4px;
}

.title-span {
  flex: 1;
  text-align: center;
}

.close-icon {
  width: 20px;
  height: 20px;
}

.modal-body {
  max-height: 90vh;
  overflow-y: auto;
  z-index: 999999;
}
</style>
